module.exports = __webpack_public_path__ + "static/media/MaisonNeue-MediumItalic.0d67f307.woff2";